/** What a read's answer does, once it is known to be the current one. */
export interface LatestHandlers<T> {
  done: (value: T) => void
  failed: (err: unknown) => void
  settled?: () => void
}

/** Starts a read for an effect and returns the effect's cleanup. The cleanup aborts
 *  the read, so a superseded request stops on the server and its answer never lands. */
export function latestRead<T>(read: (signal: AbortSignal) => Promise<T>, on: LatestHandlers<T>): () => void {
  const ctl = new AbortController()
  const live = () => !ctl.signal.aborted
  read(ctl.signal)
    .then(
      (value) => {
        if (live()) on.done(value)
      },
      (err: unknown) => {
        if (live()) on.failed(err)
      },
    )
    .finally(() => {
      if (live()) on.settled?.()
    })
  return () => ctl.abort()
}
